import React from 'react';
import CouponsEdaPage from './CouponsEdaPage';
import CouponAssessmentForm from './CouponAssessmentForm';
import './CouponsPage.css';

const CouponsPage: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Coupon Acceptance Analysis</h1>
      <p>
        This analysis explores factors that influence whether a customer will accept a coupon. The
        study focuses on bar coupons and restaurant coupons, examining how demographics, driving
        scenarios, and customer behavior affect coupon acceptance rates.
      </p>

      <div className="coupons-assessment">
        <h2>Coupon Acceptance Prediction</h2>
        <p>
          Use the form below to predict whether a customer will accept a coupon based on various
          factors such as demographics, driving conditions, and coupon details.
        </p>
        <CouponAssessmentForm />
      </div>

      <div className="coupons-analysis">
        <h2>Coupon Acceptance Analysis</h2>
        <CouponsEdaPage />
      </div>
    </div>
  );
};

export default CouponsPage;
